import React from 'react';
import Loader from '@amzn/meridian/loader';
import Row from '@amzn/meridian/row';
import { LoaderProps } from '@amzn/meridian/loader/loader';

export const CenteredLoader = (props: LoaderProps) => (
  <Row
    alignmentHorizontal='center'
    alignmentVertical='center'
    spacingInset='500 none 500 none'
  >
    <Loader {...props} />
  </Row>
);

export default CenteredLoader;
